import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { Grid } from '../Grid';
import { View } from '../View';
import FormGroupContent from './FormGroupContent';
import { useFormGroup } from './useFormGroup';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('./useFormGroup').Props, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function FormGroup(props, forwardedRef) {
  var _useFormGroup = useFormGroup(props),
      contentProps = _useFormGroup.contentProps,
      horizontal = _useFormGroup.horizontal,
      otherProps = _objectWithoutProperties(_useFormGroup, ["contentProps", "horizontal"]);

  if (horizontal) {
    return /*#__PURE__*/React.createElement(Grid, Object.assign({
      templateColumns: "minmax(0, 1fr) 2fr"
    }, otherProps, {
      ref: forwardedRef
    }), /*#__PURE__*/React.createElement(FormGroupContent, contentProps));
  }

  return /*#__PURE__*/React.createElement(View, Object.assign({}, otherProps, {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(FormGroupContent, contentProps));
}
/**
 * `FormGroup` is a form component that groups a label with a form element (e.g. `Switch` or `TextInput`).
 *
 * @example
 * ```jsx
 * import { FormGroup, TextInput } from `@wp-g2/components`
 *
 * function Example() {
 * 	return (
 * 		<FormGroup label="First name">
 * 			<TextInput />
 * 		</FormGroup>
 * 	)
 * }
 * ```
 */


var ConnectedFormGroup = contextConnect(FormGroup, 'FormGroup');
export default ConnectedFormGroup;